import request from '@/utils/request'

export function main(id) {
  return request({
    url: `/api/app/browser/main-assets/${id}`,
    method: 'get'
  })
}

export function assetsTable(data) {
  return request({
    url: '/api/app/browser/wallet-addr-assets',
    method: 'post',
    data,
  })
}

export function tradeTable(data) {
  return request({
    url: '/api/app/browser/wallet-addr-transaction',
    method: 'post',
    data,
  })
}

export function addr(params) {
  return request({
    url: '/api/app/browser/wallet-addr',
    method: 'get',
    params,
  })
}